import { Button, PlusIcon } from "melco-ui";
import { Key } from "react";
import { useTranslation } from "react-i18next";

export type BulkActionAddFilterDesignsProps = {
  allDesigns?: any[];
  selectedRowKeys: Key[];
  setSelectedRowKeys: (keys: Key[]) => void;
  setDesignsFilter: any;
  designsFilter: any;
};

export const BulkActionAddFilterDesigns: React.FC<
  BulkActionAddFilterDesignsProps
> = ({
  allDesigns,
  selectedRowKeys,
  setSelectedRowKeys,
  setDesignsFilter,
  designsFilter,
}) => {
  const { t } = useTranslation();
  //const { addDesigns } = useAddRemoveDesigns();
  const isFilterAlreadyAdded = (file_name: string) => {
    return designsFilter?.find((c: any) => c.label == file_name);
  };

  const addDesigns = (toAdd: any[]) => {
    const addedDesigns = toAdd
      .filter((c) => !isFilterAlreadyAdded(c.file_name))
      .map((design) => {
        const { file_name } = design;
        return {
          label: file_name,
          value: file_name,
        };
      });

    setDesignsFilter([...(designsFilter ?? []), ...addedDesigns]);
    return addedDesigns;
  };

  return (
    <>
      {selectedRowKeys.length > 0 && (
        <Button
          icon={<PlusIcon />}
          // type="primary"
          onClick={() => {
            if (allDesigns) {
              const designsToAdd = allDesigns.filter((c: any) => {
                return selectedRowKeys.includes(c.file_name!);
              });

              addDesigns(designsToAdd);
              setSelectedRowKeys([]);
            }
          }}
        >
          {t("reporting.statistics.filters.machineGroup.add.add_selected")}
        </Button>
      )}
    </>
  );
};
